import { connect } from 'react-redux';

import {
  ordersDetailsInvalidate,
  ordersDetailsFetchIfNeeded,
  ordersSetViewedFetch,
  ordersSetViewedFetchIfNeeded,
  ordersFilesFetchIfNeeded,
  ordersSetFavoriteFetch,
  ordersSetStatusReservedFetch,
  ordersSetStatusRejectedFetch,
  ordersSetStatusRejectedAcceptedFetch,
  ordersSetStatusAcceptedFetch,
  ordersSetStatusRevisionCompletedFetch,
  ordersMessagesFetch,
  ordersMessagesSetReadFetch,
  ordersMessagesAddFetch,
  ordersMessagesAddConfirmFetch,
  ordersMessagesDeleteConfirmFetch,
  orderFileUploadFetch,
  orderFilesUploadFetch,
  ordersMessagesAddAttachFetch,
  ordersFilesRemoveFetch,
  ordersHideInLists,
  updateOrderField,
  ordersSetStatusJoinChatFetch,
  ordersSetStatusRejectJoinChatFetch,
} from 'store/orders/actions';
import { ordersFindFetchIfNeeded } from 'store/ordersFind/actions';

import { removeTakenNotification } from 'store/ordersNotifications/actions';

import Order from 'components/order/Order';

import { closeModalComponent } from 'store/modals/actions';

import { getTakenOrderNotifications } from '../store/ordersNotifications/selectors';

const mapStateToProps = (state, ownProps) => {
  const { orderNumber } = ownProps;
  const order = state.orders[orderNumber] || {};
  const isTaken = getTakenOrderNotifications(state).includes(orderNumber);
  const { user } = state;
  const error = order.error || null;
  const isFilesLoading = !order.files || order.files.isFetching || order.files.didInvalidate;
  const isMessagesLoading = !order.messages || order.messages.isFetching || order.messages.didInvalidate;
  const isLoading = order.isFetching || order.didInvalidate || isFilesLoading || isMessagesLoading;
  const fileItems = !order.files || !order.files.items ? {} : order.files.items;
  const fileWebhook = !order.files || !order.files.webhook ? '' : order.files.webhook;
  const messageList = !order.messages || !order.messages.items ? [] : Object.values(order.messages.items);
  const isLoadingAdd = !order.messages ? true : order.messages.isFetchingAdd;
  const isStatusLoading = order.isFetchingStatus || false;
  const hasClientChatNotification = Boolean((state.clientChatNotifications.notifications.find(it => it.node === order.jabber_node) || {}).count) || false;
  return {
    isLoading, order, error, fileItems, fileWebhook, isStatusLoading, messageList, isLoadingAdd, user, checkUser: true, isTaken, hasClientChatNotification,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { orderNumber, onSelect } = ownProps;

  return {
    loadDetails: _orderNumber => new Promise((resolve, reject) => {
      try {
        dispatch(ordersDetailsFetchIfNeeded(_orderNumber || orderNumber)).then(async (json = {}) => {
          if (json.noFetch) {
            resolve();
            return;
          }

          if (!json.details) {
            onSelect(orderNumber);
            resolve();
            return;
          }

          const { details: { _id: orderId, is_recommended: isRecommended, is_suggested: isSuggested } } = json;
          if (isRecommended || isSuggested) {
            dispatch(ordersSetViewedFetch(orderNumber, orderId));
          } else {
            dispatch(ordersSetViewedFetchIfNeeded(orderNumber, orderId));
          }

          await dispatch(ordersFilesFetchIfNeeded(orderNumber, orderId));
          await dispatch(ordersMessagesFetch(orderNumber, orderId));
          resolve();
        });
      } catch (e) {
        console.error(e);
        reject();
      }
    }),
    orderSetViewed: orderId => dispatch(ordersSetViewedFetchIfNeeded(orderNumber, orderId)),
    invalidate: () => dispatch(ordersDetailsInvalidate(orderNumber)),
    loadOrders: () => dispatch(ordersFindFetchIfNeeded()),
    setFavorite: value => dispatch(ordersSetFavoriteFetch(orderNumber, value)),
    setReserved: () => dispatch(ordersSetStatusReservedFetch(orderNumber)),
    setRejected: () => dispatch(ordersSetStatusRejectedFetch(orderNumber)),
    setAccepted: () => dispatch(ordersSetStatusAcceptedFetch(orderNumber)),
    setJoinChat: () => dispatch(ordersSetStatusJoinChatFetch(orderNumber)),
    setRejectJoinChat: payload => dispatch(ordersSetStatusRejectJoinChatFetch(orderNumber, payload)),
    setRejectAccepted: payload => dispatch(ordersSetStatusRejectedAcceptedFetch(orderNumber, payload)),
    setRevisionCompleted: () => dispatch(ordersSetStatusRevisionCompletedFetch(orderNumber)),
    setMessageRead: (messageId, message) => dispatch(ordersMessagesSetReadFetch(orderNumber, messageId, message)),
    addMessage: (to, message) => dispatch(ordersMessagesAddFetch(orderNumber, to, message)),
    addMessageConfirm: (to, message, files) => dispatch(ordersMessagesAddConfirmFetch(orderNumber, to, message, files)),
    deleteMessageConfirm: (number, message) => dispatch(ordersMessagesDeleteConfirmFetch(number, message)),
    uploadFile: (file, group) => dispatch(orderFileUploadFetch(orderNumber, file, group, null, ['final'])),
    uploadOrderFiles: (files = [], group) => dispatch(orderFilesUploadFetch(orderNumber, files, group, ['final'])),
    addMessageAttach: (to, files, message) => dispatch(ordersMessagesAddAttachFetch(orderNumber, to, files, message)),
    removeFile: fileId => dispatch(ordersFilesRemoveFetch(orderNumber, fileId)),
    hideInLists: () => dispatch(ordersHideInLists(orderNumber)),
    removeTakenNotification: () => dispatch(removeTakenNotification(orderNumber)),
    updateOrderFieldHandler: payload => dispatch(updateOrderField(orderNumber, payload)),
    closeModalComponentHandler: component => dispatch(closeModalComponent(component)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Order);
